'use client';

import { useWatchlistContext } from '@benzinga/user-context';
import { FaPlus } from 'react-icons/fa';

import { WidgetStatus } from '../../../edge/dashboard/_components/WidgetStatus';
import { widgetPrimaryButtonClassName } from '../../../edge/dashboard/_components/widgetChrome';

export const WatchlistEmptyState = () => {
  const { setShowCreateModal } = useWatchlistContext();

  return (
    <WidgetStatus
      action={
        <button type="button" className={widgetPrimaryButtonClassName} onClick={() => setShowCreateModal(true)}>
          <FaPlus size={12} />
          Create watchlist
        </button>
      }
      description="Follow the stocks and crypto you care about, compare performance, and manage alerts in one place."
      title="Create your first watchlist"
    />
  );
};
